export const NOTIFICATIONS_UPDATED_EVENT = 'webcert:notifications-updated'